export default {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  FEDERATION: 'FEDERATION',
  ORGANISATION: 'ORGANISATION',
  ORGANISATION_GROUP: 'ORGANISATION_GROUP',
};
